module.exports = __webpack_public_path__ + "media/components/Agencies/Layouts/SideMenu/analyticsIcon-ff7c46759dd37a21e4d180ec266beb07.svg";